import * as Types from '../../constants/actionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case Types.GET_LIST_USER_NOTIFICATION: {
            return {
                ...state,
                newNotification: action.newNotification,
                oldNotification: action.oldNotification
            }
        }
        case Types.REQUEST_LIST_USER_NOTIFICATION_ERROR: {
            return {
                ...state,
                requestListNotiError: action.error,
            }
        }

        default:
            return state;
    }
};
